import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CompanyModel } from 'app/models/company.model';
import { CompanyService } from 'app/services/company.service';
import { ShiftsService } from 'app/services/shifts.service';
import { ShiftFormComponent } from 'app/modules/shifts/form/shift-form.component';
import { ErrorDialogComponent } from 'app/shared/dialogs/error-dialog/error-dialog.component';
import { ThemePaletteService } from 'app/services/theme-palette.service';
import { StorageKeysService } from 'app/shared/services/storage-keys.service';
import { BehaviorSubject, filter, firstValueFrom, Observable, take, timeout } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DevstroupeInitAppService {
    private _currentCompany = new BehaviorSubject<CompanyModel>(null);
    currentCompany$: Observable<CompanyModel> = this._currentCompany.asObservable();

    constructor(
        private themePaletteService: ThemePaletteService,
        private companyService: CompanyService,
        private _skey: StorageKeysService,
        private dialog: MatDialog,
        private shiftsService: ShiftsService,
    ) {}

    init(): Promise<void> {
        const token = localStorage.getItem(this._skey.token);
        if (!token) return Promise.resolve();

        return firstValueFrom(
            this.companyService.currentCompany$.pipe(
                filter((c) => !!c),
                take(1),
                timeout(5000),
            ),
        )
            .then(async (company) => {
                this.themePaletteService.applyPrimaryColor(company.primary_color);
            })
            .catch((err) => {
                console.warn('Init service: não recebeu company dentro do timeout, continuando bootstrap.', err);
                return;
            });
    }
}
